import { URL } from "config/config";
import { showAlert } from "./alert";
import { get } from "lodash";
import axios from "axios";

export const SET_CUSTOMERS_LOADING = 'SET_CUSTOMERS_LOADING';
export const SET_CUSTOMERS = 'SET_CUSTOMERS';
export const SET_CUSTOMER_DETAILS_LOADING = 'SET_CUSTOMER_DETAILS_LOADING';
export const SET_CUSTOMER_DETAILS = 'SET_CUSTOMER_DETAILS';
export const SET_CUSTOMER_BOOKINGS_LOADING = 'SET_CUSTOMER_BOOKINGS_LOADING';
export const SET_CUSTOMER_BOOKINGS = 'SET_CUSTOMER_BOOKINGS';

const setCustomersLoading = (value = true) => ({
    type: SET_CUSTOMERS_LOADING,
    payload: value
});
const setCustomersList = (value) => ({
    type: SET_CUSTOMERS,
    payload: value
});
const setCustomerDetailsLoading = (value = true) => ({
    type: SET_CUSTOMER_DETAILS_LOADING,
    payload: value
});
const setCustomersDetails = (value) => ({
    type: SET_CUSTOMER_DETAILS,
    payload: value
});
const setCustomerBookingsLoading = (value = true) => ({
    type: SET_CUSTOMER_BOOKINGS_LOADING,
    payload: value
});
const setCustomerBookings = (value) => ({
    type: SET_CUSTOMER_BOOKINGS,
    payload: value
});

export const fetchCustomersByOrg = (orgId, query = "") => async dispatch => {
    try {
        dispatch(setCustomersLoading(true));
        const response = await axios.get(`${URL.CUSTOMERS_BY_ORG}/${orgId}?${query}`);
        if (response && response.data.success) {
            const data = get(response, 'data.objects', []);
            dispatch(setCustomersList(data));
            dispatch(setCustomersLoading(false));
            return response?.data
        }
        dispatch(setCustomersLoading(false));
    } catch (err) {
        dispatch(setCustomersLoading(false));
        if (err?.message) {
            dispatch(showAlert('error', err?.message))
        }
    };
}
export const findCustomersById = (customerId) => async dispatch => {
    try {
        dispatch(setCustomerDetailsLoading(true));
        const response = await axios.get(`${URL.CUSTOMERS_BY_ID}/${customerId}`);
            
        if (response && response.data.success) {
            const data = get(response, 'data.object', null );
            dispatch(setCustomersDetails(data));
            dispatch(setCustomerDetailsLoading(false));
            return response?.data
        }
        dispatch(setCustomerDetailsLoading(false));
    } catch (err) {
        dispatch(setCustomerDetailsLoading(false));
        if (err?.message) {
            dispatch(showAlert('error', err?.message))
        }
    };
}

export const fetchCustomerBookings = (customerId, query = "") => async dispatch => {
    try {
        dispatch(setCustomerBookingsLoading(true));
        const response = await axios.get(`${URL.CUSTOMER_BOOKINGS}/${customerId}?${query}`);
        if (response && response.data.success) {
            const data = get(response, 'data.objects', []);
            dispatch(setCustomerBookings(data));
            dispatch(setCustomerBookingsLoading(false));
            return response?.data
        }
        dispatch(setCustomerBookingsLoading(false));
    } catch (err) {
        dispatch(setCustomerBookingsLoading(false));
        if (err?.message) {
            dispatch(showAlert('error', err?.message))
        }
    };
}